import { render, staticRenderFns } from "./MediumComList.vue?vue&type=template&id=71268b55"
import script from "./MediumComList.vue?vue&type=script&lang=js"
export * from "./MediumComList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports